import { getTradingIntent } from "features/onboarding/guided/intent";

const key = (userId: number) => `onboarding-quick-connect:${userId}`;

export const saveQuickConnectIntent = (
  userId: number | undefined,
  authUrl: string
) => {
  if (!userId || !window.location.pathname.startsWith("/register/")) return;
  const query = new URLSearchParams(window.location.search);
  const method = getTradingIntent(query);
  const state = new URL(authUrl).searchParams.get("state");
  if (!method || !state) return;
  const parameters = Object.fromEntries(
    ["groupID", "botUUID"].flatMap((name) =>
      query.get(name) ? [[name, query.get(name)!]] : []
    )
  );
  try {
    localStorage.setItem(
      key(userId),
      JSON.stringify({ state, method, parameters, timestamp: Date.now() })
    );
  } catch {}
};

export const consumeQuickConnectIntent = (
  userId: number | undefined,
  state: string | null
): Record<string, string> | undefined => {
  if (!userId || !state) return;
  try {
    const saved = JSON.parse(localStorage.getItem(key(userId)) || "null");
    if (!saved || saved.state !== state) return;
    localStorage.removeItem(key(userId));
    if (Date.now() - saved.timestamp > 30 * 60 * 1000) return;
    if (!getTradingIntent(new URLSearchParams({ method: saved.method })))
      return;
    return {
      ...saved.parameters,
      method: saved.method,
      guided: "0",
      startMode: "",
      connectLive: "",
    };
  } catch {
    return;
  }
};
